export function isExpertizoLocation(latitude, longitude, tolerance = 0.00015) {
  const EXPERTIZO_LAT = 24.8833188;
  const EXPERTIZO_LNG = 67.0662084;

  if (
    typeof latitude !== "number" ||
    typeof longitude !== "number" ||
    isNaN(latitude) ||
    isNaN(longitude)
  ) {
    return false;
  }

  const latDiff = Math.abs(latitude - EXPERTIZO_LAT);
  const lngDiff = Math.abs(longitude - EXPERTIZO_LNG);

  return latDiff <= tolerance && lngDiff <= tolerance;
}



// WEBPACK FOOTER //
// ./src/utils/expertizoLocation.js